export const historicalData = {
  historicalData: "Historical Data",
  units: "Units",
  taktTime: "Takt Time",
  operatingTime: "Operating Time",
  idealCycleTime: "Ideal Cycle Time",
  plannedStopTime: "Planned Stop Time",
  unplannedStopTime: "Unplanned Stop Time",
  goodCount: "Good Count",
  numberOfBreakdowns: "Number Of Breakdowns",
  totalMaintenaceTime: "Total Maintenace Time",
  numberOfRepairs: "Number Of Repairs",
  machineId: "Machine Id",
  producedUnits: "Produced Units",
};
